export enum AccountType {
  SettlementAccount = "SettlementAccount",
  CardAccount = "CardAccount",
  ClosedAccount = "ClosedAccount",
}

export enum AccountStatus {
  Open = "Open",
  Closed = "Closed",
}

export enum AccountApiUrls {
  Accounts = "/v1/Accounts",
  AccountTransactions = "/v1/Accounts/:accountId/Transactions",
  AccountRename = "/v1/Accounts/:accountNumber/Rename",
  AccountRequisite = "/v1/Accounts/:accountId/Requisites",
  AccountStatement = "/v1/Accounts/:accountId/Statements",
  AccountStatementExport = "/v1/Accounts/:accountId/Statements/Export",
  AccountRequisiteExport = "/v1/Accounts/:accountId/Requisites/Export",
  AccountHolder = "/v1/Accounts/:accountNumber/Holder",
}

export enum AccountApiTagTypes {
  AccountList = "AccountList",
}
